import React, { useEffect, useRef } from 'react';
import { View, ScrollView, TouchableOpacity, Text, StyleSheet, Image } from 'react-native';
import Colors from '../../assets/Colors';
import CachedImage from '../CachedImage'

function HomeVideo({ params }) {
  const iframeRef = useRef(null);
  const src = "https://www.youtube.com/embed/" + window.appData.video.id + "?autoplay=1&mute=1&controls=0&enablejsapi=1&loop=1&playlist=" + window.appData.video.id;
  const styleVideoCard = {
    width: '90%',
    aspectRatio: window.appData.video.aspectRatio,
    backgroundColor: 'gray',
  };

  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      if (params.currentIndex === 1) {
        iframeRef.current.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      } else {
        iframeRef.current.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    }
  }, [params.currentIndex]);

  return (
    <View style={styleVideoCard}>
      <iframe
        ref={iframeRef}
        width="100%"
        height="100%"
        src={src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </View>
  );
};


function GenereMusicale({ genere, params }) {

  const genereClick = () => {
    params.setHomeGenere(genere);
    params.scrollToScreen('Search');
  };

  return (
    <TouchableOpacity onPress={genereClick}>
      <CachedImage
        source={genere}
        style={styles.image}
        alt={genere}
      />
    </TouchableOpacity >
  );
}

export default function Home({ params }) {
  return (
    <>
      <ScrollView keyboardDismissMode="on-drag" contentContainerStyle={styles.scrollViewContent}>
        <View style={styles.pageTitle}>
          <Text style={styles.pageTitleText}>Mercato Musicale</Text>
        </View>

        {window.appData.video.id ? (
          <View style={styles.videoContainer}>
            <HomeVideo params={params} />
          </View>
        ) : null
        }

        <View style={styles.gridContainer}>
          {window.appData.generiMusicali.map((item, index) => (
            <View key={index} style={styles.gridItem}>
              <GenereMusicale genere={item} params={params} />
              <Text style={styles.gridItemLabel}>{item}</Text>
            </View>
          ))}
        </View>
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  scrollViewContent: {
    flexGrow: 1,
  },
  pageTitle: {
    textAlign: 'center',
    alignItems: 'center',
    marginBottom: 23,
  },
  pageTitleText: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  videoContainer: {
    alignItems: 'center',
    marginBottom: 20,
  },
  gridContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'top',
    paddingHorizontal: 6,
  },
  gridItem: {
    width: '45%',
    aspectRatio: 0.93,
    margin: 5,
    borderRadius: 10,
    paddingHorizontal: 5,
  },
  gridItemLabel: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 10,
  },
  image: {
    borderRadius: 10,
    aspectRatio: 1,
    width: '100%',
    height: undefined,
    overflow: 'hidden',
  },
});